import React from 'react';

// 自己説明の「決定」を押した直後に出る確認ダイアログ。
// 説明シートは常時表示なので、問が切り替わる瞬間だけはここで明示的に区切る
// （学習者が「回答が受け付けられた」ことと「次に進む」ことを取り違えないようにする）。
// isLast: 最終問題では次の問題へ進まず、完了したことだけを伝える。
function ExerciseAdvanceDialog({ isLast = false, onAdvance }) {
  return (
    <div className="advance-dialog-backdrop">
      <div className="advance-dialog" role="alertdialog" aria-modal="true">
        {isLast ? (
          <>
            <p className="advance-dialog__title">すべての問題に答えました</p>
            <p className="advance-dialog__note">【演習を終える】を押してください。</p>
            <button type="button" className="btn-sheet" onClick={onAdvance}>
              演習を終える
            </button>
          </>
        ) : (
          <>
            <p className="advance-dialog__title">次の問題に進みます</p>
            <p className="advance-dialog__note">準備ができたら【進む】を押してください。</p>
            <button type="button" className="btn-sheet btn-sheet--attention" onClick={onAdvance}>
              進む
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default ExerciseAdvanceDialog;
